import React, { ReactElement } from "react";
import { useRenderOn } from "src/hooks/useRenderOn";

interface IProps {
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

// tslint:disable-next-line:no-any
type IWithRenderOn = (props: IProps) => ReactElement<any, any>;

const withRenderOn = (Component: typeof React.Component): IWithRenderOn => {
  return (props: IProps): JSX.Element => {
    const renderOnProps = useRenderOn();

    return <Component {...props} renderOnProps={renderOnProps} />;
  };
};

export default withRenderOn;
